import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import earningApis from "../../../App/api/earning.apis";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { columns,searchBy,filters,canlenderFilter } from "./Column.js";
import EarningModal from "../EarningModal.jsx";
const Orders = ({meta}) => {
 
  

  const [selectedData, setSelectedData] = useState(null);
  const [isEarningModal, setIsEarningModal] = useState(false);
  const [search,setSearch]=useState("")
  const debounceTimeout = useRef(null); 

  const handleClose=()=>{
    setIsEarningModal(false)
    setSelectedData(null)
  }
   const [pagination,setPagination]=useState({
      "page": 1,
      "limit": 5,
      "sortOrder": "desc",
      "filter": {}
    })
   const {value, fetchAllData } = useFetchAll(() =>earningApis.getAllOrdersEarning(pagination,search));
    // Table Functions @started
    const handlePagination=(data)=>{
      // console.log(data);
      
      if (data.clearPagination) {
        setPagination(data.clearPagination)
        return
      }
      
      setPagination((prev)=>{
        let copyfilter={...prev.filter}
        // copyfilter[]
        
        if (data.filter) {
          // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
          // console.log("Object.keys[copyfilter]",Object.keys(data.filter))
          
          if (copyfilter[Object.keys(data.filter)[0]]) {
            copyfilter[Object.keys(data.filter)[0]]=Object.values(data.filter)[0]
            
          }else{
            
              copyfilter={...data?.filter,...copyfilter}
            }
            
          }
         
          
          return{
            page:data.page?data.page:prev.page,
            limit:data.limit?data.limit:prev.limit,
            sortOrder:data.sortOrder?data.sortOrder:prev.sortOrder,
            filter:copyfilter
          }
          
        })
      }
      const handleRowClick = (row) => {
        // console.log("row", row);
        setSelectedData(row);
        // setIsOrderDetail(true);
      };
      const handleCellClick =async (cell,field="") => {
        console.log("click on profile:",field);
        console.log("cell", cell);
    
        if (field==="orderId") {      
          setSelectedData(cell);
          setIsEarningModal(true)
        }
       
      };
    
     
    
      const onPaginatorClick = (e) => {
        if (e) {
          // console.log("Paginator Clicked",e);
         //  const row={
         //   filters: null,
         //   first: 0,
         //   multiSortMeta: [],
         //   page: 0,
         //   rows: 10,
         //   sortField: null,
         //   sortOrder: null,
         //   totalPages: 2   
         // }
         const data={
          limit:e.rows,
          page:+e.page+1
         }
         handlePagination && handlePagination(data)
         // handlePagination && handlePagination(e.row,limit,sortOrder,filter)
        }
      
      };
    
      const handleSearch = useCallback((s) => {
        console.log('Search at OrderCom', s);
        setSearch(s);
    }, []);
    
    const debouncedSearch = useCallback((s) => {
      if (debounceTimeout.current) {
          clearTimeout(debounceTimeout.current);
      } 
      debounceTimeout.current = setTimeout(() => {
          handleSearch(s); 
      }, 1500);
    }, [handleSearch]);
    
    
    const handleClearFilter=()=>{
    const clearPagination=  {
        "page": 1,
        "limit": 5,
        "sortOrder": "desc",
        "filter": {}
      }
      // console.log('clearPagination',clearPagination);
      handlePagination && handlePagination({clearPagination})
    }
    const handleFilter=(name,value)=>{
    console.table('name,value',name,value);
    let data={}
    if (name==='search_by') {
      data.sortOrder=value.code
    }
    else{
     
      const filter={}
      filter[`orderDetails.${name}`]=value.code?value.code:value
      data.filter=filter
      
    }
    
    handlePagination && handlePagination(data)
    
    
  }
  
  // Table Functions @end
  
  console.log('data',value?.data?.earnings);

      useEffect(() => {
        fetchAllData()
      }, [pagination,search]);

  return (
    <div className='main-content'>
      <CommonLayout />
        <BasicTable
              columns={columns}
              data={value?.data?.earnings}
              onPaginatorClick={onPaginatorClick}
              paginatorData={{
                filters: null,
                first: 0,
                multiSortMeta: [],
                page: value?.data?.page||1,
                rows: value?.data?.limit||5,
                sortField: null,
                sortOrder: null,
                totalPages: value.data?.totalPages||1  ,
                totalCount: value.data?.totalCount||1  
              }}
              onCellClick={(e)=>{console.log("Cell Data",e)}}
              SearchBy={searchBy}
              handleSearch={debouncedSearch}
              handleFilter={(name,value)=>handleFilter(name,value)}
              handleClearFilter={handleClearFilter}
              filters={filters}
              WeekRange={false}
              MonthRange={true}
              canlenderFilter={canlenderFilter}
              selectedData={selectedData}
              handleCellClick={handleCellClick}
              // handleRowClick={(row) => handleRowClick(row)}
            />

            <EarningModal isEarningDetail={isEarningModal} handleClose={()=>handleClose()} earningData={selectedData} />
    </div>
  );
};

export default Orders;
